/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_App_UrlInputs */

const en_admin_settings_fields_app_url = /** @type {(inputs: Admin_Settings_Fields_App_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App URL`)
};

/**
* | output |
* | --- |
* | "App URL" |
*
* @param {Admin_Settings_Fields_App_UrlInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_app_url = /** @type {((inputs?: Admin_Settings_Fields_App_UrlInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_App_UrlInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_app_url(inputs)
});
export { admin_settings_fields_app_url as "admin.settings.fields.app_url" }